// Critical functionality that's needed for the login/registration/public endpoints to work
import '../src/javascripts/i18n';
import '../src/javascripts/slide_roller'
import '../src/javascripts/common'
import '../src/javascripts/autosave'
import '../src/javascripts/adalia_form'
import '../src/javascripts/fathom'

import Login from '../src/javascripts/login';
import { User } from '../src/javascripts/user'

window.ActionJS = {}
window.ActionJS.User = User;
window.ActionJS.Login = Login;